"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TweetPanel = void 0;
var react_1 = __importDefault(require("react"));
var react_twitter_widgets_1 = require("react-twitter-widgets");
var styled_components_1 = __importDefault(require("styled-components"));
var BlogPanel_1 = __importDefault(require("./BlogPanel"));
var TweetPanel = function (props) {
    var user = props.user, twitterTheme = props.twitterTheme, className = props.className;
    return (react_1.default.createElement(BlogPanel_1.default, { className: className },
        react_1.default.createElement(TweetsContainer, null,
            react_1.default.createElement(react_twitter_widgets_1.Timeline, { dataSource: { sourceType: 'profile', screenName: user }, options: {
                    username: user,
                    height: '500',
                    chrome: 'noheader',
                    theme: twitterTheme,
                } }))));
};
exports.TweetPanel = TweetPanel;
var TweetsContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  height: 450px;\n"], ["\n  overflow: hidden;\n  height: 450px;\n"])));
exports.default = exports.TweetPanel;
var templateObject_1;
